import React, { useState } from "react";
import { Nav } from "react-bootstrap";
import "./AppraisalProgress.css";
import AppraisalList from "./AppraisalList";
import Header from "./AppraisalList/component/Header/Header";

const QuarterlyAppraisalProgress = () => {
  const [tab, setTab] = useState("engine");

  return (
    <>
      <Header title="Quarterly Appraisals" />
      <Nav variant="tabs" className="mb-3 px-3" activeKey={tab} onSelect={setTab}>
        <Nav.Item>
          <Nav.Link eventKey="engine">Quarterly PAFs</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="aggregated">Aggregated Quarterly PAFs</Nav.Link>
        </Nav.Item>
      </Nav>
      {tab === "engine" ? (
        <AppraisalList key="engine" baseFilters={{ frequency: "Quarterly", listSource: "engine" }} />
      ) : (
        <AppraisalList key="aggregated" baseFilters={{ frequency: "Quarterly", listSource: "aggregated" }} />
      )}
    </>
  );
};

export default QuarterlyAppraisalProgress;
